import {
  SearchX, Clock, ImageOff, Building2, Camera, TrendingDown,
  ScanFace, Store, Handshake, GalleryHorizontalEnd, ShieldCheck,
  CreditCard, Download, QrCode, Hotel, Layers, Palmtree, PartyPopper,
  Sparkles, Zap, PackageCheck, Lock, Mail, Globe, Aperture,
} from "lucide-react";

export const ICONS = {
  SearchX, Clock, ImageOff, Building2, Camera, TrendingDown,
  ScanFace, Store, Handshake, GalleryHorizontalEnd, ShieldCheck,
  CreditCard, Download, QrCode, Hotel, Layers, Palmtree, PartyPopper,
  Sparkles, Zap, PackageCheck, Lock, Mail, Globe, Aperture,
};

export const Icon = ({ name, className = "", strokeWidth = 1.5 }) => {
  const Cmp = ICONS[name] || Sparkles;
  return <Cmp className={className} strokeWidth={strokeWidth} />;
};
